export type CookieKey = 'CK_CUSTOMER_INFO' | 'CK_LANG_CODE' | 'CK_ISO_CODE' | 'CK_DISPLAY_TYPE' | 'CK_CART_INFO' | 'CK_CURRENCY_CODE' | 'lt_token_id' | 'CartSessionID';
export const STORAGE_KEY_PRFIX: string = 'tf-custom-standard-oligo';
export const STORAGE_TYPE: string = 'asyncStorage'; // localforage's INDEXDB implementation by default
export const COOKIE_KEYS: {
  CK_CUSTOMER_INFO: CookieKey,
  CK_LANG_CODE: CookieKey,
  CK_ISO_CODE: CookieKey,
  CK_DISPLAY_TYPE: CookieKey,
  CK_CART_INFO: CookieKey,
  CK_CURRENCY_CODE: CookieKey,
  LT_TOKEN_ID: CookieKey,
  CART_SESSION_ID: CookieKey,
} = {
  CK_CUSTOMER_INFO: 'CK_CUSTOMER_INFO',
  CK_LANG_CODE: 'CK_LANG_CODE',
  CK_ISO_CODE: 'CK_ISO_CODE',
  CK_DISPLAY_TYPE: 'CK_DISPLAY_TYPE',
  CK_CART_INFO: 'CK_CART_INFO',
  CK_CURRENCY_CODE: 'CK_CURRENCY_CODE',
  LT_TOKEN_ID: 'lt_token_id',
  CART_SESSION_ID: 'CartSessionID',
};

export function hasBrowserSupport(propertyName: string): boolean {
  return window[propertyName] && (typeof window[propertyName] === 'object' || typeof window[propertyName] === 'function');
}

export function hasLocalFileSupport(): boolean {
  return hasBrowserSupport('FileReader') &&
         hasBrowserSupport('File') &&
         hasBrowserSupport('FileList') &&
         hasBrowserSupport('Blob');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/client.ts